export default __webpack_public_path__ + "static/media/user_activity_51.0156912f.png";